import { nip19 } from 'nostr-tools';
import { siteConfig } from '@/config/site';

/** The site owner's pubkey (hex), decoded from `siteConfig.ownerNpub`. */
export const ownerPubkey: string = (() => {
  try {
    const decoded = nip19.decode(siteConfig.ownerNpub);
    if (decoded.type === 'npub') return decoded.data;
  } catch {
    // Invalid npub in config — feed will show the empty state.
  }
  return '';
})();

/** External profile URL (njump) for any hex pubkey. */
export function njumpUrl(pubkey: string): string {
  return `https://njump.me/${nip19.npubEncode(pubkey)}`;
}

/** Truncate a long hex/bech32 string for display: `abcd…wxyz`. */
export function truncateMiddle(value: string, head = 8, tail = 6): string {
  if (value.length <= head + tail + 1) return value;
  return `${value.slice(0, head)}…${value.slice(-tail)}`;
}
